import { FaUsers, FaEnvelope, FaBriefcase, FaSearch, FaUser, FaEdit, FaTrash, FaPlus, FaSave, FaTimes } from "react-icons/fa";
import { useState, useEffect } from "react";
import { useAuth } from "./AuthContext";

export default function MemberProfiles() {
  const { user } = useAuth();
  const isAdmin = user?.isProfileAdmin || false;
  
  // Core admins who can manage admin rights (hardcoded - these cannot be removed)
  const CORE_ADMINS = ["js9640@nyu.edu", "ks5404@nyu.edu", "mxa5271@nyu.edu"];
  const isCoreAdmin = CORE_ADMINS.includes(user?.email) || user?.isAdmin;

  const [members, setMembers] = useState([
    // Steering Committee
    {
      id: 1,
      name: "Josie Simm",
      role: "Chair",
      department: "Provost Office",
      email: "js9640@nyu.edu",
      committees: ["Steering Committee"],
      status: "active",
      isAdmin: true, // Core admin
    },
    {
      id: 2,
      name: "Mohammed Waseem Chaudry",
      role: "Vice Chair",
      department: "Student Affairs",
      email: "mwc347@nyu.edu",
      committees: ["Steering Committee"],
      status: "active",
      isAdmin: false,
    },
    {
      id: 3,
      name: "Karol Tolpa",
      role: "Academic Staff Committee Chair",
      department: "Social Science Division",
      email: "kjt9854@nyu.edu",
      committees: ["Steering Committee", "Academic Staff"],
      status: "active",
      isAdmin: false,
    },
    {
      id: 4,
      name: "Anand Kant Das",
      role: "Researcher Committee Chair",
      department: "Science Division",
      email: "akd6@nyu.edu",
      committees: ["Steering Committee", "Researchers"],
      status: "active",
      isAdmin: false,
    },
    {
      id: 5,
      name: "Eudora Okine",
      role: "Communications Officer",
      department: "At-Large Member",
      email: "eo50@nyu.edu",
      committees: ["Steering Committee", "Administrative Staff"],
      status: "active",
      isAdmin: false,
    },
    {
      id: 6,
      name: "Shreekanth Nair",
      role: "Governance Liaison Officer",
      department: "Administrative and Business Operations",
      email: "sn1245@nyu.edu",
      committees: ["Steering Committee", "Administrative Staff"],
      status: "active",
    },
    {
      id: 7,
      name: "Sabah Siddiqui",
      role: "HR Officer",
      department: "Administrative and Business Operations",
      email: "ss5552@nyu.edu",
      committees: ["Steering Committee", "Administrative Staff"],
      status: "active",
    },
    {
      id: 8,
      name: "Amnah Khan",
      role: "Belonging Officer",
      department: "Science Division",
      email: "ask9190@nyu.edu",
      committees: ["Steering Committee", "Academic Staff"],
      status: "active",
    },
    // Academic Staff
    {
      id: 9,
      name: "Abigail Cahill",
      role: "Academic Librarian",
      department: "Academic Staff",
      email: "alc9738@nyu.edu",
      committees: ["Academic Staff"],
      status: "active",
    },
    {
      id: 10,
      name: "Valeriya Golovina",
      role: "Arts and Humanities Division",
      department: "Academic Staff",
      email: "vig211@nyu.edu",
      committees: ["Academic Staff"],
      status: "active",
    },
    {
      id: 11,
      name: "Ibrahim Chehade",
      role: "At-Large Member",
      department: "Academic Staff",
      email: "iyc1@nyu.edu",
      committees: ["Academic Staff"],
      status: "active",
    },
    {
      id: 12,
      name: "Samia Ahmed",
      role: "Center for Writing",
      department: "Academic Staff",
      email: "sa2696@nyu.edu",
      committees: ["Academic Staff"],
      status: "active",
    },
    {
      id: 13,
      name: "Wahib Mufid Salim",
      role: "Engineering Division",
      department: "Academic Staff",
      email: "wms5@nyu.edu",
      committees: ["Academic Staff"],
      status: "active",
    },
    // Administrative Staff
    {
      id: 14,
      name: "Abigail Abbot",
      role: "Administrative and Business Operations",
      department: "Administrative Staff",
      email: "aha9268@nyu.edu",
      committees: ["Administrative Staff"],
      status: "active",
    },
    {
      id: 15,
      name: "Dimitar Dimitrov",
      role: "Administrative and Business Operations",
      department: "Administrative Staff",
      email: "dd2529@nyu.edu",
      committees: ["Administrative Staff"],
      status: "active",
    },
    {
      id: 16,
      name: "Janice Liu",
      role: "External Relations & Communications",
      department: "Administrative Staff",
      email: "jl6159@nyu.edu",
      committees: ["Administrative Staff"],
      status: "active",
    },
    {
      id: 17,
      name: "Susan Havlis",
      role: "Research Institute",
      department: "Administrative Staff",
      email: "slh12@nyu.edu",
      committees: ["Administrative Staff"],
      status: "active",
    },
    {
      id: 18,
      name: "Caitlin Newsom",
      role: "Provost Office",
      department: "Administrative Staff",
      email: "cn1065@nyu.edu",
      committees: ["Administrative Staff"],
      status: "active",
    },
    {
      id: 19,
      name: "Holly Mace",
      role: "Provost Office",
      department: "Administrative Staff",
      email: "hem8@nyu.edu",
      committees: ["Administrative Staff"],
      status: "active",
    },
    {
      id: 20,
      name: "Hind Abuelrish",
      role: "Provost Office",
      department: "Administrative Staff",
      email: "ha50@nyu.edu",
      committees: ["Administrative Staff"],
      status: "active",
    },
    {
      id: 21,
      name: "Helen Taunga",
      role: "Student Affairs",
      department: "Administrative Staff",
      email: "st5035@nyu.edu",
      committees: ["Administrative Staff"],
      status: "active",
    },
    {
      id: 22,
      name: "Abdulla Alnuaimi",
      role: "Vice Chancellor's Office",
      department: "Administrative Staff",
      email: "ama10295@nyu.edu",
      committees: ["Administrative Staff"],
      status: "active",
    },
    // Researchers
    {
      id: 23,
      name: "Israa Mahgoub",
      role: "Arts and Humanities Division",
      department: "Researchers",
      email: "iam4@nyu.edu",
      committees: ["Researchers"],
      status: "active",
    },
    {
      id: 24,
      name: "Aysha Anatoli Hamkari",
      role: "At-Large",
      department: "Researchers",
      email: "aah698@nyu.edu",
      committees: ["Researchers"],
      status: "active",
    },
    {
      id: 25,
      name: "Mohamed Abuhlaiqa",
      role: "At-Large",
      department: "Researchers",
      email: "mja9908@nyu.edu",
      committees: ["Researchers"],
      status: "active",
    },
    {
      id: 26,
      name: "Pavithra Sukumar",
      role: "Engineering Division",
      department: "Researchers",
      email: "ps157@nyu.edu",
      committees: ["Researchers"],
      status: "active",
    },
    {
      id: 27,
      name: "Maylis Boitet",
      role: "Research Centers",
      department: "Researchers",
      email: "mb9720@nyu.edu",
      committees: ["Researchers"],
      status: "active",
    },
    {
      id: 28,
      name: "Busra Mahmutoglu",
      role: "Social Science Division",
      department: "Researchers",
      email: "bm3421@nyu.edu",
      committees: ["Researchers"],
      status: "active",
    },
    // Office of Shared Governance
    {
      id: 29,
      name: "Mahra Alblooshi",
      role: "Senior Program Associate - Shared Governance",
      department: "Office of Shared Governance",
      email: "mxa5271@nyu.edu",
      committees: ["Office of Shared Governance"],
      status: "active",
      isAdmin: true, // Core admin
    },
    {
      id: 30,
      name: "Karen Sheils",
      role: "Director, Shared Governance & Policy",
      department: "Office of Shared Governance",
      email: "ks5404@nyu.edu",
      committees: ["Office of Shared Governance"],
      status: "active",
      phone: "+971 56 754 0700",
      isAdmin: true, // Core admin
    },
  ]);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRole, setSelectedRole] = useState("All");
  const [showMemberForm, setShowMemberForm] = useState(false);
  const [editingMember, setEditingMember] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    role: "",
    department: "",
    email: "",
    phone: "",
    committees: [],
    status: "active",
  });

  const roles = ["All", "Steering Committee", "Academic Staff", "Administrative Staff", "Researchers", "Office of Shared Governance"];

  // Admin functions
  const handleAddMember = () => {
    setEditingMember(null);
    setFormData({
      name: "",
      role: "",
      department: "",
      email: "",
      phone: "",
      committees: [],
      status: "active",
    });
    setShowMemberForm(true);
  };

  const handleEditMember = (member) => {
    setEditingMember(member);
    setFormData({
      name: member.name,
      role: member.role,
      department: member.department,
      email: member.email,
      phone: member.phone || "",
      committees: member.committees,
      status: member.status,
    });
    setShowMemberForm(true);
  };

  const handleDeleteMember = (memberId) => {
    if (window.confirm("Are you sure you want to delete this member?")) {
      setMembers(members.filter(m => m.id !== memberId));
    }
  };

  const handleToggleAdmin = (memberId, isAdminStatus) => {
    const updatedMembers = members.map(m => 
      m.id === memberId ? { ...m, isAdmin: isAdminStatus } : m
    );
    setMembers(updatedMembers);
    
    // Save to localStorage
    const adminEmails = updatedMembers
      .filter(m => m.isAdmin && m.email)
      .map(m => m.email);
    localStorage.setItem('staffCouncilAdmins', JSON.stringify(adminEmails));
  };

  // Load admin status from localStorage on mount
  useEffect(() => {
    const savedAdminEmails = localStorage.getItem('staffCouncilAdmins');
    if (savedAdminEmails) {
      try {
        const adminEmails = JSON.parse(savedAdminEmails);
        setMembers(prevMembers => prevMembers.map(m => ({
          ...m,
          isAdmin: adminEmails.includes(m.email) || CORE_ADMINS.includes(m.email)
        })));
      } catch (error) {
        console.error('Error loading admin settings:', error);
      }
    }
  }, []);

  // Ensure all members have isAdmin field (default to false if not set, except core admins)
  const normalizedMembers = members.map(m => ({
    ...m,
    isAdmin: m.isAdmin !== undefined ? m.isAdmin : CORE_ADMINS.includes(m.email)
  }));

  const handleSaveMember = () => {
    if (!formData.name || !formData.email) {
      alert("Name and email are required");
      return;
    }

    if (editingMember) {
      // Update existing member (preserve isAdmin status)
      setMembers(members.map(m => 
        m.id === editingMember.id 
          ? { ...formData, id: m.id, isAdmin: m.isAdmin || false }
          : m
      ));
    } else {
      // Add new member (default isAdmin to false for new members)
      const newMember = {
        ...formData,
        id: Math.max(...members.map(m => m.id)) + 1,
        isAdmin: false,
      };
      setMembers([...members, newMember]);
    }

    setShowMemberForm(false);
    setEditingMember(null);
  };

  const handleFormChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const toggleCommittee = (committee) => {
    if (formData.committees.includes(committee)) {
      setFormData({
        ...formData,
        committees: formData.committees.filter(c => c !== committee)
      });
    } else {
      setFormData({
        ...formData,
        committees: [...formData.committees, committee]
      });
    }
  };

  const filteredMembers = normalizedMembers.filter((member) => {
    const matchesSearch =
      member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      member.department.toLowerCase().includes(searchTerm.toLowerCase()) ||
      member.role.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesRole =
      selectedRole === "All" ||
      member.committees.includes(selectedRole);

    return matchesSearch && matchesRole;
  });

  const MemberCard = ({ member }) => (
    <div
      style={{
        background: "white",
        borderRadius: "12px",
        padding: "24px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
        border: "1px solid #e2e8f0",
        transition: "all 0.2s",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 0, 0, 0.12)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      <div style={{ display: "flex", gap: "20px", marginBottom: "16px" }}>
        <div
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontSize: "32px",
            flexShrink: 0,
          }}
        >
          <FaUser />
        </div>

        <div style={{ flex: 1 }}>
          <h3
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#2d3748",
              margin: "0 0 6px 0",
            }}
          >
            {member.name}
          </h3>
          <div
            style={{
              fontSize: "14px",
              color: "#667eea",
              fontWeight: "600",
              marginBottom: "4px",
            }}
          >
            {member.role}
          </div>
          <div
            style={{
              fontSize: "14px",
              color: "#718096",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <FaBriefcase style={{ fontSize: "12px" }} />
            {member.department}
          </div>
        </div>

        <span
          style={{
            padding: "4px 10px",
            height: "fit-content",
            background: member.status === "active" ? "#e6f7ee" : "#f0f0f0",
            color: member.status === "active" ? "#38a169" : "#718096",
            borderRadius: "6px",
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          {member.status.toUpperCase()}
        </span>
      </div>

      {/* Committees */}
      <div style={{ marginBottom: "16px" }}>
        <div
          style={{
            fontSize: "13px",
            fontWeight: "600",
            color: "#2d3748",
            marginBottom: "8px",
          }}
        >
          Committees:
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
          {member.committees.map((committee) => (
            <span
              key={committee}
              style={{
                padding: "4px 10px",
                background: "#f7fafc",
                border: "1px solid #e2e8f0",
                borderRadius: "6px",
                fontSize: "12px",
                color: "#4a5568",
              }}
            >
              {committee}
            </span>
          ))}
        </div>
      </div>

      {/* Contact Info */}
      <div
        style={{
          paddingTop: "16px",
          borderTop: "1px solid #f7fafc",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            fontSize: "13px",
            color: "#4a5568",
          }}
        >
          <FaEnvelope style={{ color: "#667eea", fontSize: "14px" }} />
          <a
            href={`mailto:${member.email}`}
            style={{ color: "#667eea", textDecoration: "none" }}
          >
            {member.email}
          </a>
        </div>
      </div>

      {/* Admin Status Toggle - Only for Core Admins */}
      {isCoreAdmin && (
        <div
          style={{
            paddingTop: "16px",
            marginTop: "16px",
            borderTop: "1px solid #f7fafc",
          }}
        >
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              cursor: CORE_ADMINS.includes(member.email) ? "not-allowed" : "pointer",
              padding: "10px",
              background: member.isAdmin ? "#e6f7ee" : "#f7fafc",
              borderRadius: "8px",
              border: member.isAdmin ? "1px solid #48bb78" : "1px solid #e2e8f0",
            }}
          >
            <input
              type="checkbox"
              checked={member.isAdmin || false}
              onChange={(e) => {
                if (!CORE_ADMINS.includes(member.email)) {
                  handleToggleAdmin(member.id, e.target.checked);
                }
              }}
              disabled={CORE_ADMINS.includes(member.email)}
              style={{
                cursor: CORE_ADMINS.includes(member.email) ? "not-allowed" : "pointer",
                width: "18px",
                height: "18px",
              }}
            />
            <div style={{ flex: 1 }}>
              <div style={{
                fontSize: "13px",
                fontWeight: "600",
                color: member.isAdmin ? "#38a169" : "#4a5568",
              }}>
                {member.isAdmin ? "👑 Admin Access" : "Grant Admin Access"}
              </div>
              {CORE_ADMINS.includes(member.email) && (
                <div style={{ fontSize: "11px", color: "#718096", marginTop: "2px" }}>
                  Core admin (cannot be removed)
                </div>
              )}
            </div>
          </label>
        </div>
      )}

      {/* Admin Controls */}
      {isAdmin && (
        <div
          style={{
            paddingTop: "16px",
            marginTop: "16px",
            borderTop: "1px solid #f7fafc",
            display: "flex",
            gap: "10px",
          }}
        >
          <button
            onClick={() => handleEditMember(member)}
            style={{
              flex: 1,
              padding: "8px 16px",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontSize: "13px",
              fontWeight: "600",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "6px",
            }}
          >
            <FaEdit /> Edit
          </button>
          <button
            onClick={() => handleDeleteMember(member.id)}
            style={{
              flex: 1,
              padding: "8px 16px",
              background: "#f56565",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontSize: "13px",
              fontWeight: "600",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "6px",
            }}
          >
            <FaTrash /> Delete
          </button>
        </div>
      )}
    </div>
  );

  return (
    <div
      style={{
        padding: "40px",
        maxWidth: "1400px",
        margin: "0 auto",
      }}
    >
      {/* Header */}
      <div style={{ marginBottom: "30px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <h1
            style={{
              fontSize: "32px",
              fontWeight: "700",
              color: "#2d3748",
              marginBottom: "8px",
            }}
          >
            Council Members
          </h1>
          <p style={{ color: "#718096", fontSize: "16px", margin: 0 }}>
            Connect with council members and view their profiles
          </p>
        </div>
        
        {isAdmin && (
          <button
            onClick={handleAddMember}
            style={{
              padding: "12px 24px",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "15px",
              fontWeight: "600",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              transition: "transform 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <FaPlus /> Add Member
          </button>
        )}
      </div>

      {/* Search and Filter */}
      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
          border: "1px solid #e2e8f0",
          marginBottom: "30px",
        }}
      >
        {/* Search Bar */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "16px",
            padding: "12px",
            background: "#f7fafc",
            borderRadius: "8px",
          }}
        >
          <FaSearch style={{ color: "#718096", fontSize: "16px" }} />
          <input
            type="text"
            placeholder="Search members by name, department, or role..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              flex: 1,
              border: "none",
              background: "transparent",
              outline: "none",
              fontSize: "15px",
              color: "#2d3748",
            }}
          />
        </div>

        {/* Role Filter */}
        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
          {roles.map((role) => (
            <button
              key={role}
              onClick={() => setSelectedRole(role)}
              style={{
                padding: "6px 14px",
                background: selectedRole === role ? "#667eea" : "#f7fafc",
                color: selectedRole === role ? "white" : "#4a5568",
                border: "1px solid",
                borderColor: selectedRole === role ? "#667eea" : "#e2e8f0",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "13px",
                fontWeight: selectedRole === role ? "600" : "400",
                transition: "all 0.2s",
              }}
            >
              {role}
            </button>
          ))}
        </div>
      </div>

      {/* Statistics */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "20px",
          marginBottom: "30px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: "20px",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
          }}
        >
          <div style={{ fontSize: "28px", fontWeight: "700", color: "#667eea" }}>
            {filteredMembers.length}
          </div>
          <div style={{ color: "#718096", fontSize: "14px", marginTop: "4px" }}>
            {selectedRole === "All" ? "Total Members" : selectedRole}
          </div>
        </div>
        <div
          style={{
            background: "white",
            padding: "20px",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
          }}
        >
          <div style={{ fontSize: "28px", fontWeight: "700", color: "#38a169" }}>
            {members.filter((m) => m.status === "active").length}
          </div>
          <div style={{ color: "#718096", fontSize: "14px", marginTop: "4px" }}>
            Active Members
          </div>
        </div>
      </div>

      {/* Members Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
          gap: "20px",
        }}
      >
        {filteredMembers.length > 0 ? (
          filteredMembers.map((member) => <MemberCard key={member.id} member={member} />)
        ) : (
          <div
            style={{
              gridColumn: "1 / -1",
              padding: "60px",
              textAlign: "center",
              background: "white",
              borderRadius: "12px",
              border: "1px solid #e2e8f0",
            }}
          >
            <FaUsers style={{ fontSize: "48px", color: "#cbd5e0", marginBottom: "16px" }} />
            <p style={{ color: "#718096", fontSize: "16px" }}>No members found</p>
          </div>
        )}
      </div>

      {/* Add/Edit Member Modal */}
      {showMemberForm && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "20px",
          }}
          onClick={() => setShowMemberForm(false)}
        >
          <div
            style={{
              background: "white",
              borderRadius: "12px",
              padding: "30px",
              maxWidth: "600px",
              width: "100%",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 style={{ fontSize: "24px", fontWeight: "700", color: "#2d3748", marginBottom: "20px" }}>
              {editingMember ? "Edit Member" : "Add New Member"}
            </h2>

            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              {/* Name */}
              <div>
                <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "#2d3748" }}>
                  Name *
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => handleFormChange("name", e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "14px",
                  }}
                  placeholder="Full name"
                />
              </div>

              {/* Email */}
              <div>
                <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "#2d3748" }}>
                  Email *
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => handleFormChange("email", e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "14px",
                  }}
                  placeholder="email@nyu.edu"
                />
              </div>

              {/* Role */}
              <div>
                <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "#2d3748" }}>
                  Role
                </label>
                <input
                  type="text"
                  value={formData.role}
                  onChange={(e) => handleFormChange("role", e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "14px",
                  }}
                  placeholder="Chair, Member, etc."
                />
              </div>

              {/* Department */}
              <div>
                <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "#2d3748" }}>
                  Department
                </label>
                <input
                  type="text"
                  value={formData.department}
                  onChange={(e) => handleFormChange("department", e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "14px",
                  }}
                  placeholder="Department name"
                />
              </div>

              {/* Phone */}
              <div>
                <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "#2d3748" }}>
                  Phone
                </label>
                <input
                  type="tel"
                  value={formData.phone}
                  onChange={(e) => handleFormChange("phone", e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "14px",
                  }}
                  placeholder="+971 XX XXX XXXX"
                />
              </div>

              {/* Committees */}
              <div>
                <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "#2d3748" }}>
                  Committees
                </label>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {roles.filter(r => r !== "All").map((role) => (
                    <button
                      key={role}
                      onClick={() => toggleCommittee(role)}
                      style={{
                        padding: "8px 12px",
                        background: formData.committees.includes(role) ? "#667eea" : "#f7fafc",
                        color: formData.committees.includes(role) ? "white" : "#4a5568",
                        border: "1px solid",
                        borderColor: formData.committees.includes(role) ? "#667eea" : "#e2e8f0",
                        borderRadius: "6px",
                        fontSize: "12px",
                        cursor: "pointer",
                        transition: "all 0.2s",
                      }}
                    >
                      {role}
                    </button>
                  ))}
                </div>
              </div>

              {/* Status */}
              <div>
                <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "#2d3748" }}>
                  Status
                </label>
                <select
                  value={formData.status}
                  onChange={(e) => handleFormChange("status", e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "14px",
                  }}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>

              {/* Action Buttons */}
              <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
                <button
                  onClick={handleSaveMember}
                  style={{
                    flex: 1,
                    padding: "12px",
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    fontSize: "15px",
                    fontWeight: "600",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  <FaSave /> Save Member
                </button>
                <button
                  onClick={() => setShowMemberForm(false)}
                  style={{
                    flex: 1,
                    padding: "12px",
                    background: "#f7fafc",
                    color: "#4a5568",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "15px",
                    fontWeight: "600",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  <FaTimes /> Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

